export default __webpack_public_path__ + "src/assets/Relevant_logoicon.png";